import styled, { css } from 'styled-components';
import {
    BorderRadiusMedium,
    ColorAdvice1,
    ColorAdvice4,
    ColorNordicGrey1,
    ColorNordicGrey4,
    ColorSystemAttention3,
    ColorSystemAttention5,
    ColorSystemNegative4,
    ColorSystemNegative5,
    ColorSystemPositive4,
    ColorSystemPositive5,
    FontWeightNormal,
    Spacing8,
    Spacing16
} from 'autogen/design-tokens/tokens';
import { breakpoint, sizes } from 'variables';
import Tag from '../tag';
import { Typography } from '../typography';

export type ColoredInfoboxProps = {
    text: string;
    tagText?: string;
    variant?: 'Info' | 'Positive' | 'Attention' | 'Negative';
};
function getBackgroundColor(variant: ColoredInfoboxProps['variant']) {
    switch (variant) {
        case 'Info':
            return ColorAdvice4;
        case 'Positive':
            return ColorSystemPositive5;
        case 'Attention':
            return ColorSystemAttention5;
        case 'Negative':
            return ColorSystemNegative5;
        default:
            return ColorNordicGrey4;
    }
}

const StyledTitle = styled(Typography.Title)`
    font-weight: ${FontWeightNormal};
`;

const Wrapper = styled.div<{ $variant: ColoredInfoboxProps['variant'] }>`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: start;
    gap: ${Spacing8};
    padding: ${Spacing16};
    width: 100%;
    border-radius: ${BorderRadiusMedium};

    ${({ $variant }) =>
        css`
            background-color: ${getBackgroundColor($variant)};
        `}

    ${breakpoint.up(sizes.md)} {
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }
`;

function ColoredInfobox(props: ColoredInfoboxProps) {
    const { variant, text, tagText, ...restProps } = props;

    return (
        <Wrapper $variant={variant} {...restProps}>
            <StyledTitle size="M">{text}</StyledTitle>
            {tagText && <Tag text={tagText} />}
        </Wrapper>
    );
}

export default ColoredInfobox;
